export const UploadImageHandler = {
  data () {
    return {
      uploadPercent: 0,
      showProgress: false,
    }
  },
  methods: {
    isImageAllowUpload (file) {
      const isImage = (file.type === 'image/jpeg') || (file.type === 'image/png')
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('รูปภาพต้องเป็นไฟล์ JPEG, JPG, PNG เท่านั้น!')
      }
      if (!isLt2M) {
        this.$message.error('รูปภาพต้องมีขนาดไม่เกิน 2MB!')
      }
      return isImage && isLt2M
    },
    handleExceed () {
      this.$message.warning('อัพโหลดได้ทีละรูปเท่านั้น!')
    },
    onProgress (percent) {
      this.uploadPercent = percent
    },
  },
}
